import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Clock, DollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FeaturesSection = () => {
    const { t } = useTranslation();

    const features = [
        {
            title: t("quick_setup"),
            description: t("quick_setup_desc"),
            color: "blue",
            icon: <Rocket className="w-8 h-8 text-blue-500" />
        },
        {
            title: t("availability"),
            description: t("availability_desc"),
            color: "green",
            icon: <Clock className="w-8 h-8 text-green-500" />
        },
        {
            title: t("cost_effective"),
            description: t("cost_effective_desc"),
            color: "purple",
            icon: <DollarSign className="w-8 h-8 text-purple-500" />
        }
    ];

    return (
        <section id="features" className="py-20">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl font-bold text-center mb-16">{t("features_title")}</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {features.map((feature, index) => (
                        <motion.div 
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.2 }}
                            className="text-center"
                        >
                            <div className={`bg-${feature.color}-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6`}>
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
                            <p className="text-gray-600">{feature.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
